import { atom } from 'jotai';

export type FileUploadItemStatus = 'uploading' | 'success' | 'error';

export type FileUploadStatusItem = {
  id: string;
  fileName: string;
  status: FileUploadItemStatus;
  message?: string;
  /** 이미지 파일이면 createObjectURL로 생성한 미리보기 URL — removeItem 시 revoke */
  previewUrl?: string;
  /** 원본 File 참조. 단순 표시는 fileName만 쓰고 file은 향후 재시도 등에 사용 */
  file?: File;
};

export const fileUploadStatusItemsAtom = atom<FileUploadStatusItem[]>([]);
export const fileUploadStatusVisibleAtom = atom<boolean>(false);
export const fileUploadStatusCollapsedAtom = atom<boolean>(false);
